<section>
  <mat-card class="home-list">
    <mat-card-header>
      <mat-card-title class="pl-5"
        >Listado de expedientes - {{ fromDate | date : "dd-MM-Y" }} /
        {{ toDate | date : "dd-MM-Y" }}
        <button
          mat-icon-button
          class="float-right mr-5"
          data-toggle="collapse"
          data-target="#collapseSearch"
          aria-expanded="false"
          aria-controls="collapseSearch"
        >
          Filtrar<mat-icon>filter_alt</mat-icon>
        </button></mat-card-title
      >
    </mat-card-header>
    <mat-divider></mat-divider>
    <div class="collapse show" id="collapseSearch">
      <div *ngIf="searchForm" [formGroup]="searchForm" style="padding: 16px">
        <div class="row">
          <mat-form-field
            appearance="standard"
            class="col-lg-2 col-md-4 col-sm-10"
          >
            <mat-label>Rango fechas recepción</mat-label>
            <mat-date-range-input
              [rangePicker]="picker3"
              matTooltip="Elija un rango de fechas y pulse aceptar. Presione restablecer para volver a mostrar el rango completo de fechas."
            >
              <input
                matStartDate
                formControlName="fromDate"
                placeholder="Fecha inicio"
                [value]="fromDate"
              />
              <input
                matEndDate
                formControlName="toDate"
                placeholder="Fecha fin"
                [value]="toDate"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matSuffix
              [for]="picker3"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker3></mat-date-range-picker>
          </mat-form-field>

          <div class="botones">
            <button
              mat-button
              class="aceptar"
              (click)="applyFilter()"
              [disabled]="
                !searchForm.controls['fromDate'].value ||
                !searchForm.controls['toDate'].value
              "
            >
              Filtrar
            </button>
            <button mat-button class="restablecer" (click)="resetFechas()">
              Restablecer
            </button>
          </div>

          <!--
        <mat-form-field  class="col-lg-2 col-md-4 col-sm-12" appearance="standard">
          <mat-label>Fecha recepcion</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="entrada" (dateChange)="applyFilter()" matTooltip="Seleccione una fecha para mostrar todos los expedientes con fecha de recepción la fecha escogida.">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>


        
        <mat-form-field  class="col-lg-2 col-md-4 col-sm-12" appearance="standard">
          <mat-label>Fecha salida</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="salida" (dateChange)="applyFilter()" matTooltip="Seleccione una fecha para mostrar todos los expedientes con fecha de salida la fecha escogida.">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        -->

          <div class="col-lg-6 botones">
            <!--
            <button mat-button  class="aceptar" (click)="resetAll()" matTooltip="Presione para restablecer todos los filtros">
                          Restablecer todo <mat-icon>restart_alt</mat-icon>
            </button>
            -->
            <button
              mat-button
              class="aceptar"
              (click)="excelGenerate()"
              matTooltip="Presione para Generar una planilla excel de los datos filtrados"
            >
              Generar Excel <mat-icon>file_copy</mat-icon>
            </button>

            <button
              mat-button
              [disabled]="dowloadFiles.length === 0"
              class="aceptar"
              (click)="dowloadZip('DOCUMENTOS')"
              matTooltip="Descargar archivos de expedientes seleccionados"
            >
              <mat-icon>file_download</mat-icon>Documentos
            </button>

            <!--<button
              mat-button
              [disabled]="dowloadFacturas.length === 0"
              class="aceptar"
              (click)="dowloadZip('FACTURAS')"
              matTooltip="Descargar facturas de expedientes seleccionados"
            >
              <mat-icon>file_download</mat-icon>Facturas
            </button>-->
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2 col-md-6 col-sm-6 col-6">
            <label class="form-label">Nº Pedido</label>

            <div class="input-group">
              <div class="input-group-append">
                <input
                  type="text"
                  class="form-control"
                  formControlName="numPedido"
                  (keyup)="
                    searchForm.get('numPedido').value.length > 3
                      ? applyFilter()
                      : null
                  "
                  matTooltip="Comience a escribir un número de pedido para filtrar."
                />
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6 col-6">
            <label class="form-label">Nº Expediente</label>

            <div class="input-group">
              <div class="input-group-append">
                <input
                  type="text"
                  class="form-control"
                  formControlName="expediente"
                  (keyup)="
                    searchForm.get('expediente').value.length > 3
                      ? applyFilter()
                      : null
                  "
                  matTooltip="Comience a escribir un número de expediente para filtrar."
                />
                <span class="input-group-text"
                  ><mat-icon
                    matTooltip="Búsqueda múltiple"
                    (click)="multipleSearch()"
                    >manage_search</mat-icon
                  ></span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2 col-md-6 col-sm-6 col-6">
            <label class="form-label">Matricula</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                formControlName="matricula"
                (keyup)="
                  searchForm.get('matricula').value.length > 3
                    ? applyFilter()
                    : null
                "
                matTooltip="Comience a escribir un número de matricula para filtrar por dicho número de matricula."
              />
              <div class="input-group-append">
                <span class="input-group-text"
                  ><mat-icon
                    matTooltip="Búsqueda múltiple"
                    (click)="multipleSearchMatricula()"
                    >manage_search</mat-icon
                  ></span
                >
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6 col-6">
            <label class="form-label">Nif Cliente</label>
            <input
              type="text"
              class="form-control"
              formControlName="nifCliente"
              (keyup)="applyFilter()"
              matTooltip="Comience a escribir un NIF/CIF/NIE decliente para filtrar."
            />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Bastidor</label>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                formControlName="bastidor"
                (keyup)="applyFilter()"
                matTooltip="Comience a escribir un número de bastidor para filtrar por dicho número de bastidor."
              />
              <div class="input-group-append">
                <span class="input-group-text"
                  ><mat-icon
                    matTooltip="Búsqueda múltiple"
                    (click)="multipleSearchBastidor()"
                    >manage_search</mat-icon
                  ></span
                >
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Trámite</label>
            <select
              class="custom-select form-control"
              formControlName="tramite"
              (change)="applyFilter()"
            >
              <option value="">Todos</option>
              <option value="AYUDAS MOVES">Moves</option>
              <option value="AYUDAS REINICIA">Reinicia Auto</option>
              <option value="Matriculación">Matriculación</option>
              <option value="Cambio de propiedad">Cambio de propiedad</option>
              <option value="Notificacion venta">Notificación de venta</option>
              <option value="Distintivo medioambiental">
                Distintivo medioambiental
              </option>
              <option value="Justificante">Justificante profesional</option>
              <option value="informe">Informe</option>
              <option value="Reduccion IVA 4%">Reduccion IVA 4%</option>
              <option value="Bajas">Bajas</option>
              <option value="Custodia">Custodia</option>
              <option value="MATRICULACION INDUSTRIAL">Matriculación Industrial</option>
              <option value="MATRICULACION VEHICULO INDUSTRIAL">Matriculación Vehículo Industrial</option>
              <option value="MATRICULACION TURISMO">Matriculación Turismo</option>
              <option value="MATRICULACION VEHICULO ESPECIAL">Matriculación Vehículo Especial</option>
              <option value="MATRICULACION MOTOCICLETA">Matriculación Motocicleta</option>
              <option value="MATRICULACION CICLOMOTOR">Matriculación Ciclomotor</option>
              <option value="MATRICULACION VEHICULO IMPORTACION">Matriculación Vehículo Importación</option>
              <option value="CAMBIO DE PROPIEDAD INDUSTRIAL">Cambio de propiedad Industrial</option>
              <option value="CAMBIO DE PROPIEDAD VEHICULO INDUSTRIAL">Cambio de Propiedad Vehículo Industrial</option>
              <option value="CAMBIO DE PROPIEDAD TURISMO">Cambio de Propiedad Turismo</option>
              <option value="CAMBIO DE PROPIEDAD VEHICULO ESPECIAL">Cambio de Propiedad Vehículo Especial</option>
              <option value="CAMBIO DE PROPIEDAD MOTOCICLETA">Cambio de Propiedad Motocicleta</option>
              <option value="CAMBIO DE PROPIEDAD CICLOMOTOR">Cambio de Propiedad Ciclomotor</option>
              <option value="NOTIFICACION VENTA INDUSTRIAL">Notificación de venta Industrial</option>
              <option value="Notificación de venta a particular">Notificación Venta Particular</option>
              <option value="NOTIFICACION VENTA TURISMO">Notificación Venta Turismo</option>
              <option value="NOTIFICACION VENTA ESPECIAL">Notificación Venta Especial</option>
              <option value="NOTIFICACION VENTA MOTOCICLETA">Notificación Venta Motocicleta</option>
              <option value="NOTIFICACION VENTA CICLOMOTOR">Notificación Venta Ciclomotor</option>
            </select>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Estado</label>
            <select
              class="custom-select form-control"
              formControlName="estado"
              (change)="applyFilter()"
            >
              <option value="">Todos</option>
              <option value="FACTURADO">FACTURADO</option>
              <option value="APERTURADO">APERTURADO</option>
              <option value="EN PROCESO">EN PROCESO</option>
              <option value="PENDIENTE CEM">PENDIENTE CEM</option>
              <option value="PENDIENTE IVTM">PENDIENTE IVTM</option>
              <option value="PENDIENTE DGT">PENDIENTE DGT</option>
              <option value="INCIDENCIA">INCIDENCIA</option>
              <option value="FINALIZADO">TRAMITADO</option>
              <option value="ENVIADO">ENVIADO</option>
              <option value="PENDIENTE PRESENTACION">PENDIENTE PRESENTACION</option>
              <option value="PRESENTADO">PRESENTADO</option>
              <option value="PENDIENTE SUBSANACION">PENDIENTE SUBSANACION</option>
              <option value="EN SUBSANACION">EN SUBSANACION</option>
              <option value="CONCEDIDO - PENDIENTE JUSTIFICACION">CONCEDIDO - PENDIENTE JUSTIFICACION</option>
              <option value="DENEGADO">DENEGADO</option>
              <option value="EN JUSTIFICACION">EN JUSTIFICACION</option>
              <option value="SUBSANACION JUSTIFICACION">SUBSANACION JUSTIFICACION</option>
              <option value="PAGADO">PAGADO</option>
              <option value="CANCELADO">CANCELADO</option>
              <option value="TRAMITADO">TRAMITADO</option>
            </select>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12" *ngIf="rol === 'GRUPO'">
            <label class="form-label">Colaborador</label>
            <select
              class="custom-select form-control"
              formControlName="colaborador"
              (change)="applyFilter()"
            >
              <option value="">Todos</option>
              <option
                *ngFor="let colaborador of colaboradores"
                [value]="colaborador"
              >
                {{ colaborador }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>

    <!-- Panel de busqueda colapsable -->
    <mat-card-content>
      <!-- Tabla principal ------------------------------------------------------------------------------->
      <mat-table [dataSource]="expedientes" matSort>
        <ng-container matColumnDef="select">
          <th
            mat-header-cell
            *matHeaderCellDef
            style="border-bottom: none !important; margin-top: 6px"
          >
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [aria-label]="checkboxLabel()"
            >
            </mat-checkbox>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            style="border-bottom: none !important"
          >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="
                setExpedientesToDownloads($event.checked, row.numeroExpediente)
              "
              [checked]="selection.isSelected(row.numeroExpediente)"
              [aria-label]="checkboxLabel(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="ampliar">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Ampliar
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="ampliar">
            <button mat-icon-button>
              <mat-icon>
                <!--expand-->
                <!--add-->
                keyboard_arrow_down
              </mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <!-- Nº pedido -->
        <ng-container matColumnDef="numPedido">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Nº Pedido
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="numPedido">
            {{ element.numPedido | null }}
          </mat-cell>
        </ng-container>

        <!-- Expediente -->
        <ng-container matColumnDef="numExpediente">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Nº Expediente
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="expediente">
            {{ element.numeroExpediente | null }}
          </mat-cell>
        </ng-container>

        <!-- matricula -->
        <ng-container matColumnDef="vehiculo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Matricula
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="matricula">
            {{ element.vehiculo | null | slice : 0 : 8 }}
          </mat-cell>
        </ng-container>

        <!-- NIF cliente -->
        <ng-container matColumnDef="nifCliente">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            NIF cliente
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="NIF cliente">
            {{ element.nifCliente }}
          </mat-cell>
        </ng-container>

        <!-- bastidor -->
        <ng-container matColumnDef="bastidor">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Bastidor
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="bastidor">
            {{ element.bastidor }}
          </mat-cell>
        </ng-container>

        <!-- Tramite -->
        <ng-container matColumnDef="tramite">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Trámite
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="trámite">
            {{ element.tramite }}
          </mat-cell>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Estado
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="estado">
            {{ element.status === 'FINALIZADO' ? 'TRAMITADO' : (element.status | null) }}
          </mat-cell>
        </ng-container>
        <!-- Estado Ayuda -->
        <ng-container matColumnDef="statusAyuda">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Estado Ayuda
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="statusAyuda" [matTooltip]="getEstadoAyuda(element)">
           {{ getEstadoAyuda(element) }}
          </mat-cell>
          
        </ng-container>
        <!-- Estado firma 
        <ng-container matColumnDef="estadoFirma" >
          <mat-header-cell  *matHeaderCellDef mat-sort-header> Estado firma</mat-header-cell>
          <mat-cell  *matCellDef="let element" data-label="estado" > {{element.status | null}} </mat-cell>
        </ng-container>-->

        <!-- Colaborador -->
        <ng-container matColumnDef="colaborador">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Colaborador
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="colaborador">
            {{ element.colaborador }}
          </mat-cell>
        </ng-container>

        <!-- fecha entrada -->
        <ng-container matColumnDef="fechaEntrada">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            F.recepcion
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="F.recepcion">
            {{ element.fechaEntrada | date : "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <!-- fecha salida -->
        <ng-container matColumnDef="fechaSalida">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            F.salida
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="F.salida">
            {{ element.fechaSalida | date : "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Acciones
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="Acciones">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              click-stop-propagation
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="openDialog(element)"
                click-stop-propagation
              >
                Adjuntar archivos
              </button>
            <!--
              <button
                mat-menu-item
                (click)="abrirModalEnvioFirma(element)"
                click-stop-propagation
              >
                <span>Enviar firma </span>
              </button>
            -->
              <button
                mat-menu-item
                (click)="abrirModalComprobacionSigafirma(element)"
                click-stop-propagation
              >
                <span>Comprobar estado de firma</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          matRipple
          class="element-row fila"
          (click)="addLineasExpediente(row, i)"
          [cdkDetailRow]="row"
          [cdkDetailRowTpl]="tpl"
        >
          <!-- DETALLES -->
          <ng-template #tpl let-element>
            <div
              class="mat-row detail-row"
              [@detailExpand]
              style="overflow: hidden"
              id="{{ i }}"
              hidden
            >
              <mat-tab-group>
                <!----------- EXPEDIENTE ---------->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">assignment</mat-icon>
                    Expediente
                  </ng-template>
                  <div class="container mb-4">
                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3">
                        <label>Expediente:</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.numeroExpediente }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                        <label>Nº Factura</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.numeroDeTasa | null | titlecase }}</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-3 col-md-3 col-sm-3 p-0 col-12 mr-3">
                        <label>Nif Cliente</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nifCliente }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                        <label>Nombre Cliente</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nombreCliente | titlecase }}</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-left: 15px" *ngif="element.nifVendedor">
                      <div class="col-lg-3 col-md-3 col-sm-3 p-0 col-12 mr-3">
                        <label>Nif Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nifVendedor | null }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-sm-8 col-12 p-0">
                        <label>Nombre Cliente Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nombreVendedor | null | titlecase }}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="container1 mb-4">
                    <mat-table [dataSource]="lineasExpedientes" matSort>
                      <!-- Estado -->
                      <ng-container matColumnDef="linea">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Linea
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="Linea">
                          {{ element.numeroLinea }}
                        </mat-cell>
                      </ng-container>

                      <!-- Colaborador -->
                      <ng-container matColumnDef="descripcion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Descripcion
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="Descripcion"
                        >
                          {{ element.descripcion }}
                        </mat-cell>
                      </ng-container>

                      <!-- fecha entrada -->
                      <ng-container matColumnDef="fechaIni">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Fecha ini.
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="F.ini">
                          {{ element.fechaInicio | date : "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <!-- fecha entrada -->
                      <ng-container matColumnDef="fechaFin">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Fecha fín
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="F.fin">
                          {{ element.fechaFin | date : "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <!-- DETALLES -->

                      <mat-header-row
                        *matHeaderRowDef="lineasExpCols"
                      ></mat-header-row>
                      <mat-row
                        *matRowDef="let row; columns: lineasExpCols"
                        matRipple
                        class="element-row"
                      >
                      </mat-row>
                    </mat-table>
                  </div>
                </mat-tab>
                <!------------CLIENTE------------->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">assignment_ind</mat-icon>
                    Clientes
                  </ng-template>
                  <!-- DETALLES  Contenido cliente-->
                  <div
                    class="container2 mb-4"
                    style="width: 90%; margin-top: 20px"
                    *ngIf="cliente"
                  >
                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-2 col-md-2 col-sm-2 col-12 p-0 mr-3">
                        <label>Nif Comprador</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nifCliente }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-8 col-sm-8 col-12 p-0 mr-3">
                        <label>Nombre Comprador</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ element.nombreCliente | titlecase }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-8 col-sm-8 col-12 p-0">
                        <label>Poblacion/CP</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ cliente.codigopostalCliente }},
                              {{ cliente.poblacionCliente | titlecase }},
                              {{ cliente.provinciaCliente | titlecase }}
                            </b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 col-md-4 col-sm-4 col-12 p-0 mr-3"
                        *ngIf="
                          cliente.emailCliente != null &&
                          cliente.emailCliente.includes('@')
                        "
                      >
                        <label>Email </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ cliente.emailCliente }}</b>
                          </p>
                        </div>

                        <!--<button mat-icon-button style="display: inline-block" (click)="enviar(element, cliente)"  matTooltip="Enviar email a cliente para subida de archivos" *ngIf="cliente && cliente.emailCliente != null && cliente.emailCliente.includes('@')">
                          <mat-icon>send</mat-icon>
                        </button>-->
                      </div>

                      <div
                        class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3"
                        *ngIf="cliente.telefonoCliente != null"
                      >
                        <label>Teléfono </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ cliente.telefonoCliente }}</b>
                          </p>
                        </div>

                        <!--<button mat-icon-button style="display: inline-block" (click)="enviarSMS(expComprador,element)" matTooltip="Enviar sms al cliente par firma digital de documentos" *ngIf="checkDataComprador(cliente)">
                          <mat-icon>sms</mat-icon>
                        </button>-->
                      </div>

                      <div
                        class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                        *ngIf="!sigla"
                      >
                        <label>Direccion Comprador</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ cliente.direccionCliente | titlecase }}
                              {{ cliente.direccionnumeroCliente | titlecase }},
                              {{ cliente.direccionescaleraCliente | titlecase }}
                              {{ cliente.direccionpisoCliente | titlecase }}
                              {{ cliente.direccionpuertaCliente | titlecase }}
                            </b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                        *ngIf="sigla"
                      >
                        <label>Direccion Comprador</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ sigla.descripcion | titlecase }}
                              {{ cliente.direccionCliente | titlecase }}
                              {{ cliente.direccionnumeroCliente | titlecase }},
                              {{ cliente.direccionescaleraCliente | titlecase }}
                              {{ cliente.direccionpisoCliente | titlecase }}
                              {{ cliente.direccionpuertaCliente | titlecase }}
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      class="row"
                      style="margin-left: 15px"
                      *ngIf="clienteVendedor"
                    >
                      <div class="col-lg-2 col-md-2 col-sm-2 col-12 p-0 mr-3">
                        <label>Nif Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ clienteVendedor.nifCliente }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-8 col-sm-8 col-12 p-0 mr-3">
                        <label>Nombre Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ clienteVendedor.nombreCliente | titlecase }}
                              {{ clienteVendedor.apellido1Cliente | titlecase }}
                              {{
                                clienteVendedor.apellido2Cliente | titlecase
                              }}</b
                            >
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-8 col-sm-8 col-12 p-0">
                        <label>Poblacion/CP</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ clienteVendedor.codigopostalCliente }},
                              {{
                                clienteVendedor.poblacionCliente | titlecase
                              }},
                              {{ clienteVendedor.provinciaCliente | titlecase }}
                            </b>
                          </p>
                        </div>
                      </div>
                      <div
                        class="col-lg-3 col-md-4 col-sm-4 col-12 p-0 mr-3"
                        *ngIf="
                          clienteVendedor.emailCliente != null &&
                          clienteVendedor.emailCliente.includes('@')
                        "
                      >
                        <label>Email </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ clienteVendedor.emailCliente }}</b>
                          </p>
                        </div>
                        <!--<button mat-icon-button style="display: inline-block" (click)="enviar(element, clienteVendedor)"  matTooltip="Enviar email a cliente para subida de archivos" *ngIf="clienteVendedor && clienteVendedor.emailCliente != null && clienteVendedor.emailCliente.includes('@')">
                          <mat-icon>send</mat-icon>
                        </button>-->
                      </div>

                      <div
                        class="col-lg-3 col-md-3 col-sm-3 col-12 p-0 mr-3"
                        *ngIf="cliente.telefonoCliente != null"
                      >
                        <label>Teléfono </label><br />
                        <div class="borde m-0" style="display: inline-block">
                          <p>
                            <b>{{ clienteVendedor.telefonoCliente }}</b>
                          </p>
                        </div>
                        <!--<button mat-icon-button style="display: inline-block" (click)="enviarSMS(expVendedor, element)"  matTooltip="Enviar sms al cliente par firma digital de documentos" *ngIf="checkDataVendedor(clienteVendedor)">
                          <mat-icon>sms</mat-icon>
                        </button>-->
                      </div>

                      <div
                        class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                        *ngIf="siglaVendedor"
                      >
                        <label>Direccion Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b
                              >{{ siglaVendedor.descripcion | titlecase }}
                              {{ clienteVendedor.direccionCliente | titlecase }}
                              {{
                                clienteVendedor.direccionnumeroCliente
                                  | titlecase
                              }},
                              {{
                                clienteVendedor.direccionescaleraCliente
                                  | titlecase
                              }}
                              {{
                                clienteVendedor.direccionpisoCliente | titlecase
                              }}
                              {{
                                clienteVendedor.direccionpuertaCliente
                                  | titlecase
                              }}
                            </b>
                          </p>
                        </div>
                      </div>

                      <div
                        class="col-lg-9 col-md-9 col-sm-12 col-12 p-0 mr-3"
                        *ngIf="!siglaVendedor"
                      >
                        <label>Direccion Vendedor</label>
                        <div class="borde m-0">
                          <p>
                            <b>
                              {{ clienteVendedor.direccionCliente | titlecase }}
                              {{
                                clienteVendedor.direccionnumeroCliente
                                  | titlecase
                              }},
                              {{
                                clienteVendedor.direccionescaleraCliente
                                  | titlecase
                              }}
                              {{
                                clienteVendedor.direccionpisoCliente | titlecase
                              }}
                              {{
                                clienteVendedor.direccionpuertaCliente
                                  | titlecase
                              }}
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div
                      class="row"
                      style="margin-left: 15px"
                      *ngIf="
                        (element.tramite == 'CAMBIO DE PROPIEDAD' &&
                          !element.nifPoseedor) ||
                        (element.tramite == 'CAMBIO DE PROPIEDAD' &&
                          element.nifPoseedor != 'null')
                      "
                    >
                      <div class="col-lg-3 col-md-2 col-sm-2 label">
                        <p>NIF Poseedor:</p>
                      </div>
                      <div class="col-lg-8 col-md-6 col-sm-6 label">
                        <p>Nombre poseedor:</p>
                      </div>
                    </div>
                    <div
                      class="row"
                      *ngIf="
                        (element.tramite == 'CAMBIO DE PROPIEDAD' &&
                          !element.nifPoseedor) ||
                        (element.tramite == 'CAMBIO DE PROPIEDAD' &&
                          element.nifPoseedor != 'null')
                      "
                    >
                      <div class="col-lg-3 col-md-2 col-sm-2 borde">
                        <p>
                          <b>{{ element.nifPoseedor | null }}</b>
                        </p>
                      </div>
                      <div class="col-lg-8 col-md-6 col-sm-6 borde">
                        <p>
                          <b>{{ element.nombrePoseedor | null | titlecase }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </mat-tab>
                <!------------VEHICULO------------->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon"
                      >directions_car_filled</mat-icon
                    >
                    Vehículo
                  </ng-template>
                  <!-- DETALLES  Vehiculo   ---------------------------------------->
                  <div class="contenedor3 mb-4" *ngIf="vehiculo">
                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
                        <label>Nif Propietario</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.nifPropietario | null }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
                        <label>Matricula</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.matricula | null }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-sm-3 p-0 pr-3">
                        <label>F.Matriculación</label>
                        <div class="borde m-0">
                          <p *ngIf="vehiculo.fechaMatriculacion">
                            <b>{{
                              vehiculo.fechaMatriculacion
                                | null
                                | date : "dd/MM/yyyy"
                            }}</b>
                          </p>
                          <p *ngIf="!vehiculo.fechaMatriculacion"><b> - </b></p>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-3 p-0">
                        <label>1ra Matriculación</label>
                        <div class="borde m-0">
                          <p *ngIf="vehiculo.fechaPrimeraMatriculacion">
                            <b>{{
                              vehiculo.fechaPrimeraMatriculacion
                                | null
                                | date : "dd/MM/yyyy"
                            }}</b>
                          </p>
                          <p *ngIf="!vehiculo.fechaPrimeraMatriculacion">
                            <b> - </b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 p-0 pr-3">
                        <label>Bastidor</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.bastidor | null }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 p-0">
                        <label>Tipo</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.tipoVehiculo | null }}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-2 col-md-4 col-sm-4 p-0 pr-3">
                        <label>Marca</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.marca | null }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-8 col-sm-8 p-0 pr-3">
                        <label>Modelo</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.modelo | null }}</b>
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
                        <label>Color</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.color }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-2 col-md-6 col-sm-6 p-0 pr-3">
                        <label>Carburante</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.carburante | null }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-1 col-md-2 col-sm-2 p-0 pr-3">
                        <label>Plazas</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.plazas | null }}</b>
                          </p>
                        </div>
                      </div>

                      <div class="col-lg-2 col-md-2 col-sm-2 p-0">
                        <label>Cilindrada</label>
                        <div class="borde m-0">
                          <p>
                            <b>{{ vehiculo.cilindrada | null }}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    aria-label=""
                    class="float-right"
                    (click)="abrirModal()"
                  >
                    <mat-icon>info</mat-icon>
                  </button>
                </mat-tab>
                <!------------AYUDA------------->
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">electrical_services</mat-icon>
                  Ayudas
                </ng-template>
                <!-- DETALLES  Contenido ayuda-->
                <div
                  class="container2 mb-4"
                  style="width: 90%; margin-top: 20px">

                  <mat-table
                      [dataSource]="ayudas"
                      matSort
                      style="width: 100%"
                    >
                      <!-- Usuario -->
                      <ng-container matColumnDef="tipoAyuda">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Tipo de ayuda
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="tipoAyuda"
                        >
                          {{ element.tipoAyuda }}
                        </mat-cell>
                      </ng-container>

                      <!-- Estado de la ayuda -->
                      <ng-container matColumnDef="estadoAyuda">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Estado
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="estadoAyuda">
                          {{ element.estadoAyuda | null}}
                        </mat-cell>
                      </ng-container>

                      <!-- Número de expediente de la ayuda -->
                      <ng-container matColumnDef="expedienteAyuda">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Número de expediente
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="expedienteAyuda"
                        >
                          {{ element.expedienteAyuda }}
                        </mat-cell>
                      </ng-container>
                      <!-- Importe de la ayuda -->
                      <ng-container matColumnDef="importeAyuda">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Importe de la ayuda
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="importeAyuda"
                        >
                          {{ element.importeAyuda }}
                        </mat-cell>
                      </ng-container>

                      <mat-header-row
                        *matHeaderRowDef="lineasAyudas"
                      ></mat-header-row>
                      <mat-row
                        *matRowDef="let row; columns: lineasAyudas"
                        matRipple
                        class="element-row"
                      >
                      </mat-row>
                    </mat-table>
                  
                  <hr />
                </div>
                <button
                    mat-icon-button
                    aria-label=""
                    class="float-right"
                    (click)="abrirModalAyuda()"
                  >
                    <mat-icon>info</mat-icon>
                  </button>
              </mat-tab>
                <!------------INCIDENCIA------------->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon"
                      >assignment_late</mat-icon
                    >
                    Incidencias
                  </ng-template>
                  <!-- TABLA INCIDENCIAS ------------------------------------------->
                  <div class="container1 tabla-in mb-4">
                    <mat-table
                      [dataSource]="lineasIncidencias"
                      matSort
                      style="width: 100%"
                    >
                      <!-- Usuario -->
                      <ng-container matColumnDef="usuario">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Usuario
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="Usuario"
                        >
                          {{ element.usuario }}
                        </mat-cell>
                      </ng-container>

                      <!-- Accion -->
                      <ng-container matColumnDef="accion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Acción
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="Accion">
                          {{ element.accionARealizar }}
                        </mat-cell>
                      </ng-container>

                      <!-- fecha recepcion -->
                      <ng-container matColumnDef="frecepcion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          F.Recepción
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="F.Recepción"
                        >
                          {{ element.fechaRecepcion | date : "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <!-- Estado-->
                      <ng-container matColumnDef="estado">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Estado
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element" data-label="Estado">
                          {{ element.estado }}
                        </mat-cell>
                      </ng-container>

                      <!-- Incidencia-->
                      <ng-container matColumnDef="incidencia">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Incidencia
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="Incidencia"
                        >
                          {{ element.descripcion }}
                        </mat-cell>
                      </ng-container>

                      <!-- Fecha resolucion-->
                      <ng-container matColumnDef="fresolucion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          F.Resolución
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="F.Resolución"
                        >
                          {{ element.fechaResolucion | date : "dd/MM/yyyy" }}
                        </mat-cell>
                      </ng-container>

                      <!-- Descripcion-->
                      <ng-container matColumnDef="descripcion">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                          Descripción
                        </mat-header-cell>
                        <mat-cell
                          *matCellDef="let element"
                          data-label="Descripción"
                        >
                          {{ element.descripcionTipo }}
                        </mat-cell>
                      </ng-container>

                      <!-- DETALLES -->

                      <mat-header-row
                        *matHeaderRowDef="lineasInCol"
                      ></mat-header-row>
                      <mat-row
                        *matRowDef="let row; columns: lineasInCol"
                        matRipple
                        class="element-row"
                      >
                      </mat-row>
                    </mat-table>
                  </div>
                </mat-tab>
                <!-----------DOCUMENTOS------------->
                <mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">description</mat-icon>
                    Documentos
                  </ng-template>
                  <!-- DETALLES  Contenido cliente -->
                  <!-- <div class="container2 mb-4" style="width: 90%; margin-top: 20px" *ngIf="cliente && sigla"> -->

                  <div
                    class="container2 mb-4"
                    style="width: 90%; margin-top: 20px"
                  >
                    <div class="row" style="margin-left: 15px">
                      <div
                        class="col-lg-3 col-md-3 col-sm-12 cajaIcono"
                        *ngFor="let doc of docList; let i = index"
                      >
                        <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                            <div class="borde m-0 text-center">
                              <div class="checkbox-container">
                                <div style="display: flex; align-items: center">
                                  <mat-checkbox
                                    style="margin-right: 8px; margin-top: 7px"
                                    checked="true"
                                    disabled
                                  ></mat-checkbox>
                                  <p>
                                    <b>{{ doc.typeSettings.docType.name }}</b>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                            (click)="
                              verArchivo(
                                doc,
                                element.nombreCliente,
                                vehiculo.matricula
                              )
                            "
                          >
                            <div class="espacio">
                              <img src="assets/icons/download.png" width="35" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-12 cajaIcono">
                        <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                            <div class="borde m-0 text-center">
                              <p><b>Documentos de firma</b></p>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                            (click)="abrirModalComprobacionSigafirma(element)"
                          >
                            <div class="espacio">
                              <img src="assets/icons/download.png" width="35" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--<div class="container2 mb-4" style="width: 90%; margin-top: 20px">
                    <div class="row" style="margin-left: 15px">
                      <div class="col-lg-3 col-md-3 col-sm-12 cajaIcono" *ngFor="let doc of docList">
                        <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                            <div class="borde m-0 text-center">
                              <p><b>{{doc.typeSettings.docType.name}}</b></p>
                            </div>
                          </div>
                          <div class="col-lg-4 col-md-4 col-sm-4 cajaIcono" (click)="verArchivo(doc, element.nombreCliente , vehiculo.matricula)">
                            <div class="espacio">
                              <img src="assets/icons/download.png" width="35">
                            </div>
                          </div>
                        </div>

                      </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 cajaIcono">
                          <div class="row">
                            <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                              <div class="borde m-0 text-center">
                                <p><b>Documentos de firma</b></p>
                              </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 cajaIcono" (click)="abrirModalComprobacionSigafirma(element)">
                              <div class="espacio">
                                <img style="cursor: pointer;" src="assets/icons/download.png" width="35">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>-->
                </mat-tab>
                <!------------FACTURAS-------------->
                <!--<mat-tab>
                  <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">receipt_long</mat-icon>
                    Facturas
                  </ng-template>

                  <div
                    class="container2 mb-4"
                    style="width: 90%; margin-top: 20px"
                  >
                    <div class="row" style="margin-left: 15px">
                      <div
                        class="col-lg-3 col-md-3 col-sm-12 cajaIcono"
                        *ngFor="let doc of docList; let i = index"
                      >
                        <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                            <div class="borde m-0 text-center">
                              <div class="checkbox-container">
                                <div style="display: flex; align-items: center">
                                  <mat-checkbox
                                    style="margin-right: 8px; margin-top: 7px"
                                    checked="true"
                                    disabled
                                  ></mat-checkbox>
                                  <p>
                                    <b>{{ doc.typeSettings.docType.name }}</b>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                            (click)="
                              verFactura(
                                doc,
                                element.nombreCliente,
                                vehiculo.matricula
                              )
                            "
                          >
                            <div class="espacio">
                              <img src="assets/icons/download.png" width="35" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-12 cajaIcono">
                        <div class="row">
                          <div class="col-lg-8 col-md-8 col-sm-8 cajaName">
                            <div class="borde m-0 text-center">
                              <p><b>Documentos de firma</b></p>
                            </div>
                          </div>
                          <div
                            class="col-lg-4 col-md-4 col-sm-4 cajaIcono"
                            (click)="abrirModalComprobacionSigafirma(element)"
                          >
                            <div class="espacio">
                              <img src="assets/icons/download.png" width="35" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>-->
              </mat-tab-group>
            </div>
          </ng-template>
        </mat-row>

        <!-- DESPLEGABLE -->
      </mat-table>
      <!-- PAGINADOR -->
      <mat-paginator
        #MatPaginator
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [length]="lenghtPagination"
        showFirstLastButtons
        (page)="getServerData($event)"
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</section>
<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
  <h4 *ngIf="excelLoading" style="margin-top: 200px; color: white">
    Cargando datos del servidor para la exportación ...
  </h4>
</div>

<div
  *ngIf="spinnerFirma"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
  <h4 style="margin-top: 200px; color: white">
    Enviando datos para la firma de documentos...
  </h4>
</div>
